export default __webpack_public_path__ + "static/media/limit_100.e64828a4.svg";